// @figma file="components-web" component="HeaderIconButton"
import * as React from 'react';
import { cn } from '../../lib/utils';

export interface HeaderIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

export const HeaderIconButton = React.forwardRef<HTMLButtonElement, HeaderIconButtonProps>(
  ({ className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        'flex size-10 shrink-0 items-center justify-center rounded-full cursor-pointer',
        'bg-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/30',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);

HeaderIconButton.displayName = 'HeaderIconButton';
